import axios from 'axios';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const getOrderFilesList = ({shumaID, fileTypeID}) => {
  const data = {
    shumaID: parseInt(shumaID, 10),
    fileTypeID: parseInt(fileTypeID, 10),
  };


  return axios.post(api.GET_ORDER_FILES_LIST, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return body;
    })
    .catch((err) => {
      console.error('getOrderFilesList returns error:');
      console.error(err);
    });
};

export const getSharedFilesList = ({shumaID, fileTypeID}) => {
  const data = {
    shumaID: parseInt(shumaID, 10),
    fileTypeID: parseInt(fileTypeID, 10),
  };


  return axios.post(api.GET_SHARED_FILES_LIST, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return body;
    })
    .catch((err) => {
      console.error('getSharedFilesList returns error:');
      console.error(err);
    });
};

export const getPrivateFilesList = ({shumaID, fileTypeID}) => {
  const data = {
    shumaID: parseInt(shumaID, 10),
    fileTypeID: parseInt(fileTypeID, 10),
  };


  return axios.post(api.GET_PRIVATE_FILES_LIST, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return body;
    })
    .catch((err) => {
      console.error('getPrivateFilesList returns error:');
      console.error(err);
    });
};
